import cn from 'classnames';
import * as React from 'react';

import classes from './DrawerContent.module.scss';
import { DrawerContentProps } from './DrawerContent.types';

export const DrawerContent = ({ center, children, classes: receivedClasses = {} }: DrawerContentProps) => (
    <div className={cn(classes.root, center && classes.center, receivedClasses.root)}>{children}</div>
);
